import AbsComponent from "../../components/AbsComponent";

export default class SideCategory extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el=''){
        super(_name, _store, _actions, _router, _el);

        this.setting();
        this.addEvents();
        
        const watchC1 = this.watch(this.store.getState, 'category1', this.isEqual);
        this.store.subscribe( watchC1( this.render.bind(this) ) );
        
        const watchC2 = this.watch(this.store.getState, 'category2', this.isEqual);
        this.store.subscribe( watchC2( this.render.bind(this) ) );
    }

    setting(){
        axios( {
            method: 'GET',
            url: `${this.store.getState().config.apiDomain}/game/item/categories`,
            params: { locale: this.store.getState().config.locale }
        })
        .then( (_res) => {
            let template = _res.data.map( (it, d1) => {
                let sub = it.childFilterList.map( (sub, d2) =>{
                    // @see https://teams.microsoft.com/l/message/19:51c336ac8cee4b4e96e983683dd04c5a@thread.v2/1710401207039?context=%7B%22contextType%22%3A%22chat%22%7D
                    // FIXME: remove 'Mark' after changing BE API data
                    const subName = sub.name || 'Mark';
                    return `<li data-dep="${it.id}-${sub.id}"><button class="btn-category" data-d1="${it.id}" data-d2="${sub.id}">${subName}</button></li>`;
                }).join('');
                return `<li data-dep="${it.id}"><button class="btn-category" data-d1="${it.id}">${it.name}</button><ul>${sub}</ul></li>`;
            }).join('');
            jQuery(this.el + ' ul').append(template);

            this.render();
            this.addEvents();
        })
        .catch( (error, d) => console.log(error,this.name, d) )
        .then( (d) => {} );
    }

    render(_data = {}){
        $(this.el + ' .is-active').removeClass('is-active');
        let d1 = this.store.getState().category1;
        let d2 = this.store.getState().category2;
        
        $(this.el + ` li[data-dep="${d1}"]`).addClass('is-active');
        if(d2){
            $(this.el + ` li[data-dep="${d1}-${d2}"]`).addClass('is-active');
        }
    }

    addEvents(){
        $(this.el + ' button').on('click', e=>{
            let el = $(e.currentTarget);
            let d1 = el.data('d1');
            let d2 = el.data('d2');
            
            this.router.goMultiParam({
                category1: d1,
                category2: d2? d2: '',
                page: 1
            });
        });
    }


} // end of class